import * as React from 'react';
import { useIntl, useLocation } from 'umi';
import { inject } from 'mobx-react';
import { Icon, MeetingId, Tooltip } from '@/components/index';
import { durationTime } from '@/utils/common';
import RTCModel from '@/models/rtc';
import UserModel from '@/models/user';
import Meeting from '@/models/meeting';
import Style from './index.less';

interface HeaderProps {
  operationRender?: () => React.ReactNode;
  title?: string;
  meetingNumber?: number;
  createdTime?: number;
  RTCInstance?: RTCModel;
  meeting?: Meeting;
  user?: UserModel;
}

const Header: React.FC<HeaderProps> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    user: store.user,
    meeting: store.meeting,
  };
})((props) => {
  const {
    RTCInstance,
    user,
    operationRender,
    title,
    meetingNumber,
    createdTime = 0,
    meeting,
  } = props;
  const { formatMessage } = useIntl();
  const [now, setNow] = React.useState(new Date().getTime());
  const location = useLocation();

  React.useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date().getTime());
    }, 1000);
    if (!location.pathname.includes('meeting')) {
      clearInterval(timer);
    }
    return () => {
      clearInterval(timer);
    };
  }, [location]);

  const time = React.useMemo(() => {
    if (!createdTime) return '00:00';
    return durationTime(now, createdTime);
  }, [createdTime, now]);

  // @ts-ignore
  return (
    <div className={Style.header}>
      <div className={Style.left}>
        {title && (
          <Tooltip title={title.length > 15 ? title : ''}>
            <p className={Style.title}>{title}</p>
          </Tooltip>
        )}
        {meetingNumber && (
          <>
            <div className={Style['meeting-number']}>
              {formatMessage({ id: 'CONFERENCE_NUMBER' })}：<MeetingId meetingId={meetingNumber} />
            </div>
            <div className={Style.time}>
              {!window.isMobile && <span className={Style.dot} />}
              {window.isMobile &&
                (RTCInstance?.networkQuality.has(String(user?.yxuid))
                  ? !RTCInstance?.networkQuality.get(String(user?.yxuid))
                  : false) && (
                  <Icon
                    className={`${Style['weak-network-icon']}`}
                    name="icon-signal_weak_nor"
                    size={16}
                    style={{ color: 'red' }}
                  />
                )}
              <span>{time}</span>
            </div>
            {[1, 2].includes(meeting?.videoRecordingState) && (
              <div className={Style.recording}>
                <Icon
                  className={Style.icon}
                  name="icon-luzhi"
                  size={16}
                  style={{ color: meeting?.videoRecordingState === 1 ? '#FF525D' : '#999999' }}
                />
                <span>
                  {formatMessage({
                    id: meeting?.videoRecordingState === 1 ? 'RECORDING2' : 'RECORDING_PAUSED',
                  })}
                </span>
              </div>
            )}
          </>
        )}
      </div>
      <div className={Style.right}>
        {/* <LocaleSelect short /> */}
        {operationRender && operationRender()}
      </div>
    </div>
  );
});

export default Header;
